import script from "./ApprovalFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalFlow.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalFlow.vue?vue&type=style&index=0&id=71252ffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71252ffe"]])

export default __exports__